import { Icon, IconProps } from '@chakra-ui/react'

export default function TicketPaperIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#343A40'}
      {...props}
    >
      <path
        d="M3.33331 13V14.6667C3.33331 16.5076 4.8257 18 6.66665 18H12.7858C13.6699 18 14.5179 17.6488 15.143 17.0236L16.5237 15.643C17.1488 15.0179 17.5 14.17 17.5 13.286V7.16667C17.5 5.32572 16.0076 3.83333 14.1666 3.83333H12.5"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 18V14.6667C12.5 13.7462 13.2462 13 14.1667 13H17.5"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="2.5"
        y="3"
        width="7.5"
        height="7.5"
        rx="2.5"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.42187 8.00001H5.07812"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.42187 5.50001H5.07812"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
